import React, { useMemo } from "react";
import { Select } from "kubra-ux-forge";
import { useField } from "formik";

interface SelectOneProps {
  name: string;
  label: string;
  placeholder?: string;
  options: string[];
  editableIfPrefilled?: boolean;
}

export const SelectOne: React.FC<SelectOneProps> = ({
  name,
  options,
  label,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta, helpers] = useField(name);

  const handleSelectChange = (selectedOption: any) => {
    helpers.setValue(selectedOption[0].name);
  };

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  const selectOptions = useMemo(
    () => options.map((opt) => ({ name: opt })),
    [options]
  );

  return (
    <div className="select-field-container">
      <Select
        {...field}
        defaultValue={meta.initialValue}
        label={label}
        onChange={handleSelectChange}
        options={selectOptions}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        dataCy={name}
        placeholder={placeholder}
        disabled={disabled}
        isMultiSelect={false}
      />
    </div>
  );
};
